/*基本规则结构
每个规则可以是一个对象或一个函数。如果是对象，它可以包含以下常见属性：

type: 字段的数据类型，如 string, number, boolean, array, object, enum 等。
required: 是否为必填项，默认值为 false。
min 和 max: 对于字符串表示最小/最大长度；对于数字表示最小/最大值；对于数组表示最小/最大元素数量。
pattern: 使用正则表达式进行匹配。
validator: 自定义校验函数，可以是同步也可以是异步的*/

export const accountRules = {
  username: [
    {
      required: true,
      message: '用户名是必传内容~',
      trigger: 'blur'
    } /*,
    {
      pattern: /^[a-z0-9]{5,10}$/,
      message: '用户名必须是5~10个字母或者数字~',
      trigger: 'blur'
    }*/
  ],
  password: [
    {
      required: true,
      message: '密码是必传内容~',
      trigger: 'blur'
    } /*,
    {
      pattern: /^[a-z0-9]{3,}$/,
      message: '用户名必须是3位以上的字母或者数字~',
      trigger: 'blur'
    }*/
  ],
  captchaCode: [
    {
      required: true,
      message: '请输入动态码计算结果',
      trigger: 'blur'
    }
  ]
}
